import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const PYIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="PY" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          stroke="#272727"
          strokeWidth={0.5}
          d="M8 4.25a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Z"
        />
        <Path
          fill="#F05234"
          fillRule="evenodd"
          d="M0 0v4h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#3D58DB"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          stroke="#73BE4A"
          strokeWidth={0.5}
          d="M7.339 5.088s-.563.39-.36 1.146c.202.756.991.783.991.783"
        />
        <Path
          stroke="#73BE4A"
          strokeWidth={0.5}
          d="M8.584 5.088s.563.39.36 1.146c-.202.756-.992.783-.992.783"
        />
        <Path
          fill="#FBCD17"
          fillRule="evenodd"
          d="M8.001 6.374a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
